module.exports = __webpack_public_path__ + "images/emoji/mag_right.38cc3686e598974c04e5.png";